import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/mergeMap';

import { Globals } from '../globals';

export interface InAndOut {
  active: number;
  createdAt: any;
  updatedAt: any;
  type: string;
  description: string;
}

interface InAndOutId extends InAndOut {
  id: string;
}

@Injectable()
export class InAndOutService {

  inAndOutCollection: AngularFirestoreCollection<InAndOut>;
  inAndOuts: any;

  inAndOutDocument: AngularFirestoreDocument<InAndOutId>;
  inAndOut: Observable<InAndOutId>;

  collection: string;

  // NOTE: Change this any for InAndOut Interface
  inAndOut$: Observable<any>;
  inAndOuts$: Observable<any[]>;

  constructor(
    private afs: AngularFirestore,
    private afh: FirestoreService,
    private router: Router
  ) {
    this.collection = Globals.IN_AND_OUT_COLLECTION;
  }

  /**
   * Get inAndOuts with references
   * @return {Observable} Arrays of inAndOuts
   */
  getInAndOuts(type: string) {
    if(type == "in"){
      return this.afh.colWithIds$(this.collection, ref => ref.where('type', '==', 'in').where('active', '==', true) );
    }
    if(type == 'out'){
      return this.afh.colWithIds$(this.collection, ref => ref.where('type', '==', 'out').where('active', '==', true) );
    }
    if(type == 'all'){
      return this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true) );
    }
  }

  /**
  * Get inAndOut data
  * @param {string} sid - The id of the inAndOut
  * @return {Observable} The InAndOut Object
  */
  getInAndOut(sid: string) {
    return this.inAndOut$ = this.afh.docWithIds$(this.collection + '/' + sid);
  }

  /**
  * Create new inAndOut
  * @param {InAndOut} inAndOut - The data of the inAndOut
  */
  addInAndOut(inAndOut: InAndOut) {
    this.afh.add(`${this.collection}`, inAndOut);
    this.router.navigate(['/in_and_out']);
  }

  /**
   * Update current inAndOut
   * @param {string} sid  - The id of the inAndOut
   * @param {InAndOut} inAndOut - The data of the inAndOut
   */
  updateInAndOut(sid: string, inAndOut: InAndOut) {
    this.afh.update(`${this.collection}/${sid}`, inAndOut);
    this.router.navigate(['/in_and_out']);
  }

  /**
   * Delete current inAndOut
   * @param {string} sid - The id of the inAndOut
   */
  deleteInAndOut(sid: string) {
    this.afh.delete(`${this.collection}/${sid}`);
  }

}
